<script setup lang="ts">
import { Button } from '@/components/ui/button'

import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { useForm } from '@inertiajs/vue3'

const form = useForm({
    comment: '',
})

defineProps<{
    orderId: number
}>()
</script>

<template>
    <form
        @submit.prevent="
            form.post(`/admin/orders/${orderId}/annotations`, {
                preserveScroll: true,
                onSuccess: () => {
                    form.reset()
                },
            })
        "
        class="flex flex-col gap-4"
    >
        <div class="flex flex-col gap-2">
            <Label for="comment">Adicionar comentário</Label>
            <Textarea
                type="text"
                v-model="form.comment"
                id="comment"
                placeholder="Escreva seu comentário"
                class="flex h-[100px] resize-none shadow-none"
            />
            <div class="flex flex-wrap justify-between gap-2">
                <p v-if="form.errors.comment" class="text-destructive text-xs">{{ form.errors.comment }}</p>
                <p class="ml-auto self-end text-xs text-slate-400">{{ form.comment.length }}/500</p>
            </div>
        </div>

        <Button type="submit" class="w-fit px-16">Salvar</Button>
    </form>
</template>
